import { Box, Button, IconButton } from "@mui/material";
import React, { FC, useMemo, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { useGetMyGateDevicesQuery } from "../../../redux/reducers/ots.reducer";
import { DataGrid, GridColDef, GridRenderCellParams, GridValueGetterParams } from "@mui/x-data-grid";
import { ROWS_PER_PAGE } from "../../../utils/constants";
import DeviceDetailsDialog from "./DeviceDetailsDialog";
import { useLocation, useNavigate } from "react-router-dom";

export interface IMyGateDeviceRowDetails {
	sr_no: number;
	id: number;
	device_id: string;
	is_entry: boolean;
}

const MyGateDeviceSetup: FC = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const [showDeviceDetailsDialog, setShowDeviceDetailsDialog] = useState<boolean>(false);
	const [selectedDeviceDetails, setSelectedDeviceDetails] = useState<IMyGateDeviceRowDetails | null>(null);

	// APIS
	const {
		data: getMyGateDevicesResponse,
		isLoading: getMyGateDevicesLoading,
		isFetching: getMyGateDevicesFetching,
		refetch: refetchMyGateDevices
	} = useGetMyGateDevicesQuery();
	const devicesList = useMemo<IMyGateDeviceRowDetails[]>(() => {
		if (!getMyGateDevicesResponse) return [];

		return getMyGateDevicesResponse.results.map((item, index) => ({
			sr_no: index + 1,
			id: item.id,
			device_id: item.device_id,
			is_entry: item.is_entry
		}));
	}, [getMyGateDevicesResponse]);

	function handleSaveButtonClick() {
		navigate("/ots/device-registration", { state: { ...location.state } });
	}

	function handleOpenDeviceDetailsDialog(deviceDetails: IMyGateDeviceRowDetails | null) {
		setSelectedDeviceDetails(deviceDetails);
		setShowDeviceDetailsDialog(true);
	}

	function handleCloseDeviceDetailsDialog() {
		setShowDeviceDetailsDialog(false);
		setSelectedDeviceDetails(null);
		refetchMyGateDevices();
	}

	// useEffect(() => {
	// 	if (devicesList.length <= 0) {
	// 		handleOpenDeviceDetailsDialog(null);
	// 	}
	// }, [devicesList]);

	const columnsData: GridColDef[] = [
		{
			field: "sr_no",
			headerName: "Sr. No",
			width: 100,
			sortable: false
		},
		{
			field: "device_id",
			headerName: "Device Key",
			minWidth: 200,
			flex: 1,
			sortable: false
		},
		{
			field: "is_entry",
			headerName: "Direction",
			minWidth: 200,
			flex: 1,
			sortable: false,
			valueGetter: (params: GridValueGetterParams<IMyGateDeviceRowDetails, boolean>) =>
				params.value ? "Entry" : "Exit"
		},
		{
			field: "actions",
			headerName: "",
			width: 75,
			sortable: false,
			renderCell: (params: GridRenderCellParams<IMyGateDeviceRowDetails>) => (
				<Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
					<IconButton color="info" size="small" onClick={() => handleOpenDeviceDetailsDialog(params.row)}>
						<InfoOutlinedIcon fontSize="small" />
					</IconButton>
				</Box>
			)
		}
	];

	return (
		<Box className="ots-screen-content-wrapper">
			<Box className="ots-cameras-list-screen-content">
				<Box className="ots-mygate-devices-list-screen-header">
					<Button
						disableElevation
						variant="contained"
						color="primary"
						size="small"
						sx={{ textTransform: "capitalize" }}
						startIcon={<AddIcon />}
						onClick={() => handleOpenDeviceDetailsDialog(null)}
					>
						Add New Device
					</Button>
				</Box>

				<Box className="ots-cameras-list-table-wrapper">
					<DataGrid
						columns={columnsData}
						rows={devicesList}
						disableColumnMenu
						disableRowSelectionOnClick
						density="compact"
						rowSpacingType="border"
						columnHeaderHeight={80}
						pageSizeOptions={[ROWS_PER_PAGE]}
						loading={getMyGateDevicesLoading || getMyGateDevicesFetching}
						classes={{
							columnSeparator: "ots-cameras-list-table-column-separator",
							columnHeader: "ots-cameras-list-table-column-header",
							root: "ots-cameras-list-table-root"
						}}
					/>
				</Box>
			</Box>

			<Box className="ots-form-actions-wrapper">
				{/* <Button variant="outlined" color="error" sx={{ paddingX: 5 }}>
					Back
				</Button> */}

				<Button disableElevation variant="contained" color="primary" onClick={handleSaveButtonClick}>
					Save and Next
				</Button>
			</Box>

			<DeviceDetailsDialog
				open={showDeviceDetailsDialog}
				deviceDetails={selectedDeviceDetails}
				onClose={handleCloseDeviceDetailsDialog}
			/>
		</Box>
	);
};

export default MyGateDeviceSetup;
